import CallerStateIsDisplay from './CallerStateIsDisplay'
import CallerStateIsForm from './CallerStateIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconGps from 'components/Icons/Gps'

export default {
  id: 'caller_state_is',
  label: "Caller's state is",
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/callers-state-is',
  icon: IconGps,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: CallerStateIsDisplay,
  form: CallerStateIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerStateIs/index.js